
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { SLEntity } from './entity';
import { SLEntityService } from './entity.service';
import { NotifierService } from '../../ui/alert/notifier.service';
import { DossierModel } from '../../dossier-model/dossier-model';


type ViewMode = 'step-1' | 'step-2';

/**
 * Entity new dialog
 */
@Component({
  templateUrl: './entity-new-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-560px'
          })
        ),
        transition('closed => open', animate('600ms ease-out')),
        transition('open => closed', animate('300ms ease-in')),
      ]
    ),
  ]
})
export class SLEntityNewDialogComponent implements Dialog, OnInit {
  state = 'closed';

  entity: SLEntity

  dossierModel: DossierModel

  mode: ViewMode = 'step-1'

  saving: boolean = false

  onClose: () => void
  onSave: (entity: SLEntity) => void

  constructor(
    private entityService: SLEntityService,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {
    this.entity = new SLEntity({
      type: 'COMPANY',
      address: {
        line1: '',
        line2: '',
        line3: '',
        city: '',
        zip: '',
        country: 'France',
      },
      extraFields: [],
      movements: [],
    });
  }

  close() {
    this.onClose();
  }

  submit() {

    if (this.saving || !this.entity || !this.entity.valid) {
      return;
    }

    this.saving = true;

    if (this.mode === 'step-1') {
      this.showStep('step-2');

      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.entityService
      .create(this.entity).pipe(
      finalize(onComplete))
      .subscribe((entity) => {
        this.notifier.success('Entité créée avec succès');

        this.onSave(entity);
      }, () => {
        this.saving = false;
      });
  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        this.submit();
        event.preventDefault();
        return false;
    }
  }

  showStep(mode: ViewMode, event: Event = null) {

    if (mode === 'step-1') {
      this.mode = 'step-1';
    }
    else if (mode === 'step-2' && this.entity.valid) {
      this.mode = 'step-2';
    }

    if (event) {
      event.preventDefault();
    }

    return false;
  }
}

